
export enum Language {
  EN = 'en',
  AR = 'ar',
  FR = 'fr',
  ZH = 'zh',
  RU = 'ru'
}

export type Page = 'home' | 'products' | 'cases' | 'resources' | 'about' | 'contact' | 'product-detail' | 'blog' | 'selection' | 'faq' | 'blog-detail';

export interface Product {
  id: string;
  code: string;
  name: Record<Language, string>;
  category: Record<Language, string>; 
  description: Record<Language, string>;
  specs: Record<Language, string[]>;
  imageUrl: string;
  imagePosition?: string;
  imageScale?: number;
  featured?: boolean;
  features?: Record<Language, string[]>;
  datasheetUrl?: string;
  manualUrl?: string;
  certificateUrl?: string;
  installationImageUrl?: string;
  wiringImageUrl?: string;
}

export interface CaseStudy {
  id: string;
  title: Record<Language, string>;
  location: Record<Language, string>;
  description: Record<Language, string>;
  industry: string; 
  imageUrl: string;
  imagePosition?: string;
  imageScale?: number;
}

export interface Badge {
  id: string;
  label: Record<Language, string>;
  imageUrl: string;
}

export interface Certificate {
  id: string;
  name: Record<Language, string>;
  imageUrl: string;
  imagePosition?: string;
  imageScale?: number;
}

export interface Resource {
  id: string;
  title: Record<Language, string>;
  type: 'pdf' | 'cert' | 'manual' | 'video' | 'tool'; 
  size: string;
  url: string; 
  updateDate: string;
}

export interface Testimonial {
  id: string;
  name: string;
  company: string;
  country: string;
  text: Record<Language, string>;
  rating: number;
}

export interface Partner {
  id: string;
  name: string;
  logoUrl: string; 
  imagePosition?: string;
  imageScale?: number;
}

export interface BlogPost {
  id: string;
  title: Record<Language, string>;
  excerpt: Record<Language, string>;
  content: Record<Language, string>;
  date: string;
  imageUrl: string;
  imagePosition?: string;
  imageScale?: number;
}

export interface FaqItem {
  id: string;
  question: Record<Language, string>;
  answer: Record<Language, string>;
}

export interface SEOSettings {
  title: Record<Language, string>;
  description: Record<Language, string>;
}

export type Translations = {
  [key in Language]: any;
};

export interface ChatMessage {
  role: 'user' | 'model';
  text: string;
}

// Added IndustryCategory interface to resolve import error in contexts/EditorContext.tsx
export interface IndustryCategory {
  id: string;
  label: Record<Language, string>;
  imageUrl: string;
}
